import React from "react";
import { Modal } from "antd";
import { paymentStatus } from "../options";
import { convertTimeStamp } from "utility/functions/convertTimestamp";

const DetailRow = ({ label, children, strong }) => (
  <div className="grid grid-cols-[120px_1fr] gap-2 py-1 mobile:grid-cols-1 mobile:gap-0">
    <p className="m-0 text-SKF-G-002">{label}</p>
    <div className={`m-0 text-black ${strong ? "font-bold text-SKF-Blue-001" : ""}`}>
      {children || "-"}
    </div>
  </div>
);

const DetailModal = ({ isModalOpen, handleCancel, record }) => {
  const statusLabel =
    paymentStatus.find((item) => item.value === record.status)?.label || "-";

  return (
    <Modal
      title={<span className="text-xl font-bold">票券詳情</span>}
      open={isModalOpen}
      onCancel={handleCancel}
      footer={null}
    >
      <h6 className="bg-black text-white p-3 rounded-md my-2">
        {record.status !== 4 &&
          paymentStatus.find((item) => item.value === record.status)?.label}
      </h6>
      <p>活動名稱：{record.activityTitle}</p>
      <p>參加人/Name：{record.name}</p>
      <p>票號/Ticket Number：{record.id}</p>
      <p>票價/Price：{record.price}</p>
      <p>座位/Seat：自由選位</p>
      <p>票種/Ticket Type：{record.title}</p>
      <p>
        時間/Time：
        {`${convertTimeStamp(
          record.startDateTime,
          "MM/DD ddd - HH:mm"
        )}（opens at ${convertTimeStamp(
          record.admissionStartDateTime,
          "HH:mm"
        )}）`}
      </p>
      <p>
        有效時間/Available：
        {convertTimeStamp(record.admissionStartDateTime, "MM/DD ddd - HH:mm")}
        &nbsp; - &nbsp;
        {convertTimeStamp(record.admissionEndDateTime, "MM/DD ddd - HH:mm")}
      </p>
      <p>
        活動地點/Location：
        <a href={record.locationUrl}>
          {record.location}
          {record.locationTitle !== "undefined" && `(${record.locationTitle})`}
        </a>
      </p>

        {record?.status === 4 && (
          <div className="mt-5 border-0 border-t border-solid border-[#ededed] pt-4">
            <p className="m-0 mb-3 text-SKF-G-003">入場 QR code</p>
            {record.qrCode && (
              <img
                src={`data:image/jpeg;base64,${record.qrCode}`}
                className="h-32 w-32"
                alt="QRCode"
              />
            )}
            <p className="mb-0 mt-4 text-SKF-G-003">
              字軌：{record.taxSerialNumber || "-"}
            </p>
            <p className="mt-2 text-sm text-SKF-G-002">
              內容代徵娛樂稅，本娛樂票券經{record.issuer || "-"}
              核准使用，並已向演出地之稅捐稽徵申請報繳娛樂稅
            </p>
          </div>
        )}
    </Modal>
  );
};

export default DetailModal;
